import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ErrorPage from '../../views/ErrorPage';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error(error, errorInfo);
  }

  render() {
    const {hasError} = this.state;
    if (hasError) {
      // render fallback UI
      return <ErrorPage />;
    }

    const {children} = this.props;
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
};

export default ErrorBoundary;
